/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { api, asJson } from '../lib/api.js';
import { GH, GW, PB_URL } from '../lib/config.js';
import * as store from '../lib/store.js';

export default {
  // Twee plekken voor onafgemaakt werk. Eén ervan staat altijd op de paal,
  // dus naast je huidige krabbel is er ruimte voor één ander project.
  slotKey(i) { return 'gp_proj_' + i; },

  // De twee plekken staan op de server, zodat je op elk apparaat verder kunt.
  // Lukt dat niet, dan blijft de browser zelf de reservekopie.
  async fetchProjects() {
      const me = this.state.accountId;
      if (!me || !PB_URL) return;
      try {
        const q = encodeURIComponent('accountId="' + me + '"');
        const res = await api(`${PB_URL}/api/collections/paal_projects/records?perPage=10&filter=${q}`);
        if (res.status === 404) { this.setState({ projError: 'Maak op de server een collectie “paal_projects” met tekstvelden accountId en art, en een getalveld slot.' }); return; }
        if (!res.ok) throw new Error(res.status);
        const data = await res.json();
        this.projRecs = {};
        this.projStamp = {};
        const art = [...(this.state.slotArt || ['', '', ''])];
        (data.items || []).forEach((r) => {
          const i = Number(r.slot);
          if (i !== 0 && i !== 1 && i !== 2) return;
          const t = Date.parse(String(r.updated || r.created || '').replace(' ', 'T')) || 0;
          // Staan er meer regels voor dezelfde plek, dan wint de nieuwste.
          if (this.projStamp[i] != null && t < this.projStamp[i]) return;
          this.projRecs[i] = r.id;
          this.projStamp[i] = t;
          art[i] = r.art || '';
        });
        art.forEach((a, i) => { try { store.set(this.slotKey(i), a || ''); } catch (err) {} });
        this.setState({ slotArt: art, projError: '' });
  
        // Eén keer per bezoek uitzoeken welke versie de nieuwste is: die in deze
        // browser of die op de server. Daarna niet meer, anders zou de krabbel
        // onder je handen vandaan worden getrokken terwijl je tekent.
        if (this.wipSynced || this.state.duo) return;
        this.wipSynced = true;
        // Stonden er meer beelden op de server, dan pak je de rij op waar je
        // gebleven was.
        let hadB = '';
        try { hadB = store.get('gp_wip_b') || ''; } catch (err) {}
        if (art[2] && !hadB) {
          try { store.set('gp_wip_b', art[2]); } catch (err) {}
          let mine = '';
          try { mine = store.get('gp_wip') || ''; } catch (err) {}
          const ex = this.parseExtra(art[2]);
          // Je begint altijd met één beeld; de rest klik je zelf weer aan.
          this.setState({ frames: [mine].concat(ex.art), frameOn: this.emptyOn(), frameIdx: 0 });
        }
        // De server is de baas: wat daar staat is wat je op elk apparaat ziet.
        // Alleen als je in deze sessie zelf al hebt getekend blijft jouw werk
        // staan; dan gaat dat juist naar de server toe.
        const slot = this.state.slot || 0;
        let wip = '';
        try { wip = store.get('gp_wip') || ''; } catch (err) {}
        const remote = art[slot] || '';
        // Werk in deze browser dat jonger is dan wat er op de server staat, wordt
        // nooit overschreven: dan gaat jouw versie juist naar de server. Zo blijft
        // een krabbel die je maakte vóór het inloggen gewoon staan.
        let localAt = 0;
        try { localAt = Number(store.get('gp_wip_at')) || 0; } catch (err) {}
        const remoteAt = (this.projStamp && this.projStamp[slot]) || 0;
        const localNewer = !!wip && localAt > 0 && localAt > remoteAt;
        if (!this.wipTouched && !localNewer && remote && remote !== wip) {
          try {
            store.set('gp_wip', remote);
            store.set('gp_wip_at', String(Date.now()));
          } catch (err) {}
          this.needsRestore = true;
          this.restoreWip();
        } else if (wip && wip !== remote) {
          this.saveProject(slot, wip);
        }
        // Ook de extra beelden meteen naar de server, zodat een animatie die je
        // vóór het inloggen maakte niet alleen in deze browser blijft staan. Staat
        // er op de server een jongere animatie van een ander apparaat, dan blijft
        // die staan.
        const extraRemoteAt = (this.projStamp && this.projStamp[2]) || 0;
        const extraLocalNewer = localAt > 0 && localAt > extraRemoteAt;
        if (hadB && hadB !== (art[2] || '') && (!art[2] || extraLocalNewer || this.wipTouched)) this.saveProject(2, hadB);
      } catch (e) {}
    },

  async saveProject(i, art) {
      const me = this.state.accountId;
      if (!me || !PB_URL) return;
      if (!this.projSaving) this.projSaving = {};
      // Nog een verzoek onderweg voor dit plekje? Dan dit even in de wacht,
      // anders maken twee gelijktijdige POSTs twee records voor dezelfde plek.
      if (this.projSaving[i]) { this.projQueued = this.projQueued || {}; this.projQueued[i] = art || ''; return; }
      this.projSaving[i] = true;
      const id = this.projRecs ? this.projRecs[i] : null;
      const data = { accountId: me, slot: i, art: art || '' };
      try {
        const res = id
          ? await api(`${PB_URL}/api/collections/paal_projects/records/${id}`, asJson('PATCH', data))
          : await api(`${PB_URL}/api/collections/paal_projects/records`, asJson('POST', data));
        if (!res.ok) throw new Error(res.status);
        const rec = await res.json();
        if (!this.projRecs) this.projRecs = {};
        if (rec && rec.id) this.projRecs[i] = rec.id;
        if (rec) this.projStamp = Object.assign({}, this.projStamp, { [i]: Date.now() });
        this.setState({ projError: '' });
      } catch (e) {
        this.setState({ projError: 'Opslaan op de server mislukte. Je project staat wel veilig in deze browser.' });
      } finally {
        this.projSaving[i] = false;
        const q = this.projQueued && this.projQueued[i];
        if (q != null) { delete this.projQueued[i]; this.saveProject(i, q); }
      }
    },

  readSlots() {
      const art = [0, 1].map((i) => {
        try { return store.get(this.slotKey(i)) || ''; } catch (err) { return ''; }
      });
      this.setState({ slotArt: art });
    },

  canvasArt() {
      const cv = this.canvasRef.current;
      if (!cv) return '';
      try {
        const d = this.getCtx().getImageData(0, 0, GW, GH).data;
        for (let i = 3; i < d.length; i += 4) if (d[i]) return cv.toDataURL('image/png');
      } catch (err) {}
      return '';
    },

  openProjects() {
      // De paal zelf telt als het actieve plekje: even bijwerken voor het plaatje klopt.
      const art = this.canvasArt();
      try { store.set(this.slotKey(this.state.slot), art); } catch (err) {}
      this.saveProject(this.state.slot, art);
      this.setState({ dialog: 'projects' }, () => { this.readSlots(); this.fetchProjects(); });
    },

  closeProjects() { return this.setState({ dialog: null }); },

  pickSlot(i) {
      if (i === this.state.slot) { this.setState({ dialog: null }); return; }
      if (this.state.duo) { this.notify('Tijdens samen krabbelen blijf je op hetzelfde plekje.'); return; }
      const mine = this.canvasArt();
      try { store.set(this.slotKey(this.state.slot), mine); } catch (err) {}
      this.saveProject(this.state.slot, mine);
      let next = '';
      try { next = store.get(this.slotKey(i)) || ''; } catch (err) {}
      const ctx = this.getCtx();
      if (ctx) ctx.clearRect(0, 0, GW, GH);
      const done = () => {
        try {
          if (next) store.set('gp_wip', next); else store.remove('gp_wip');
          store.set('gp_slot', String(i));
        } catch (err) {}
        this.setState({ slot: i, dialog: null, sel: null, lassoPts: null }, this.readSlots);
      };
      if (!next) { done(); return; }
      const img = new Image();
      img.onload = () => {
        if (ctx) { ctx.imageSmoothingEnabled = false; ctx.drawImage(img, 0, 0, GW, GH); }
        done();
      };
      img.onerror = done;
      img.src = next;
    }
};
